export default {
  gasolineList: {
    method: 'post',
    url: '/costing/gasoline/list?archive=ARCHIVE'
  },
  getGasolineDetail: {
    method: 'get',
    url: '/costing/gasoline/detail/ID'
  },
  getGasolineLast: {
    method: 'get',
    url: '/costing/gasoline/get-last'
  },
  updateGasoline: {
    method: 'put',
    url: '/costing/gasoline/update/ID'
  },
  createGasoline: {
    method: 'post',
    url: '/costing/gasoline/create'
  },
  deleteGasoline: {
    method: 'DELETE',
    url: '/costing/gasoline/delete/ID'
  },
  archiveGasoline: {
    method: 'DELETE',
    url: '/costing/gasoline/archive'
  },
  restoreGasoline: {
    method: 'PUT',
    url: '/costing/gasoline/restore'
  }
}
